import { Crypto, Effect, Layer, PlatformError } from 'effect';

const digest = (algorithm: Crypto.DigestAlgorithm, data: Uint8Array) =>
  Effect.tryPromise({
    try: () => globalThis.crypto.subtle.digest(algorithm, new Uint8Array(data)),
    catch: (cause) =>
      PlatformError.systemError({
        module: 'Crypto',
        method: 'digest',
        // oxlint-disable-next-line anti-slop-effect/no-manual-tagged-construction -- SystemErrorTag is PlatformError's own reason enum
        _tag: 'Unknown',
        description: 'Could not compute digest',
        cause,
      }),
  }).pipe(Effect.map((buffer) => new Uint8Array(buffer)));

export const WebCryptoLive = Layer.succeed(
  Crypto.Crypto,
  Crypto.make({
    randomBytes: (size) =>
      globalThis.crypto.getRandomValues(new Uint8Array(size)),
    digest,
  }),
);

export { randomUUID } from '@listening/utils/crypto';
